import FX6Img from '../../assets/imgs/camera_lenses_drones/fx6.jpg';
import FX3Img from '../../assets/imgs/camera_lenses_drones/fx3.jpg';
import BlackMagicImg from '../../assets/imgs/camera_lenses_drones/black_magic.jpg';
import a7r5Img from '../../assets/imgs/camera_lenses_drones/a7r_5.webp';
import a7r4Img from '../../assets/imgs/camera_lenses_drones/a7r_4.jpg';
import canonImg from '../../assets/imgs/camera_lenses_drones/canon.jpg';
import goproImg from '../../assets/imgs/camera_lenses_drones/gopro.jpg';
import phantom4Img from '../../assets/imgs/camera_lenses_drones/phantom4.jpg';
import mavicAirImg from '../../assets/imgs/camera_lenses_drones/mavic_air.jpg';
import mavic2Img from '../../assets/imgs/camera_lenses_drones/mavic_pro.png';
import sony70200Img from '../../assets/imgs/camera_lenses_drones/sony_70_200.jpg';
import sony2470Img from '../../assets/imgs/camera_lenses_drones/sony_24_70.jpg';
import canon70200Img from '../../assets/imgs/camera_lenses_drones/canon_70_200.jpg';
import metabonesImg from '../../assets/imgs/camera_lenses_drones/metabones.jpg';
import amaran200xImg from '../../assets/imgs/lights_grips/amaran_200x.jpg';
import amaran200dImg from '../../assets/imgs/lights_grips/amaran_200d.jpg';
import amaran300cImg from '../../assets/imgs/lights_grips/amaran_300c.jpg';
import arriS30rgbImg from '../../assets/imgs/lights_grips/arri_s30rgb.jpg';
import arriS30rpImg from '../../assets/imgs/lights_grips/arri_s30rp.jpg';
import hmi1200Img from '../../assets/imgs/lights_grips/hmi_1200.jpg';
import godoxSl1000Img from '../../assets/imgs/lights_grips/godox_sl1000.jpg';
import aputure300dImg from '../../assets/imgs/lights_grips/aputure_300d.jpg';
import aputure300xImg from '../../assets/imgs/lights_grips/aputure_300x.jpg';
import aputure600dImg from '../../assets/imgs/lights_grips/aputure_600d.jpg';
import aputure600xImg from '../../assets/imgs/lights_grips/aputure_600x.jpg';
import aputure1200dImg from '../../assets/imgs/lights_grips/aputure_1200d.jpg';
import neewerSoftboxImg from '../../assets/imgs/lights_grips/neewer_softbox.jpg';
import djiRoninS3Img from '../../assets/imgs/lights_grips/dji_ronin_s3.jpg';
import djiRoninS2Img from '../../assets/imgs/lights_grips/dji_ronin_s2.jpg';
import djiRoninS4Img from '../../assets/imgs/lights_grips/dji_ronin_s4.jpg';
import cameraDollyImg from '../../assets/imgs/lights_grips/camera_dolly.jpg';
import manfrotto504Img from '../../assets/imgs/lights_grips/manfrotto_504.jpg';
import manfrottoMonopodImg from '../../assets/imgs/lights_grips/manfrotto_monopod.jpg';
import cStandsImg from '../../assets/imgs/lights_grips/c_stands.jpg';
import lightStandsImg from '../../assets/imgs/lights_grips/light_stands.jpg';
import highRollerImg from '../../assets/imgs/lights_grips/high_roller.jpg';
import heavyStandsImg from '../../assets/imgs/lights_grips/heavy_stands.jpg';
import sennheiserG4Img from '../../assets/imgs/audio_other/sennheiser_g4.jpg';
import sennheiserM16Img from '../../assets/imgs/audio_other/sennheiser_m16.jpg';
import mixpreRecorderImg from '../../assets/imgs/audio_other/mixpre_recorder.png';
import zoomH6Img from '../../assets/imgs/audio_other/zoom_h6.png';
import extensionCablesImg from '../../assets/imgs/audio_other/extension_cables.jpg';
import rollCablesImg from '../../assets/imgs/audio_other/extension_cables.jpg';
import dividersImg from '../../assets/imgs/audio_other/extension_cables.jpg';
import generatorImg from '../../assets/imgs/audio_other/generator.jpg';
import memoryCardsImg from '../../assets/imgs/audio_other/memory_cards.jpg';
import deliveryServiceImg from '../../assets/imgs/audio_other/extension_cables.jpg';
import pickupServiceImg from '../../assets/imgs/audio_other/extension_cables.jpg';

const equipmentProducts = [
  {
    category: "CAMERAS",
    image: "/images/categories/cameras.jpg",
    items: [
      {
        code: "A01",
        title: "Sony FX6 Full-Frame Cinema Camera",
        description: "Professional cinema camera with full-frame sensor, 4K 120p recording",
        rate: 2500,
        image: FX6Img
      },
      {
        code: "A02",
        title: "Sony FX3 Full-Frame Cinema Camera",
        description: "Compact cinema camera with full-frame sensor, 4K 60p recording",
        rate: 2200,
        image: FX3Img
      },
      {
        code: "A03",
        title: "Blackmagic 6k Pro",
        description: "6K Super 35 sensor, EF lens mount, 13 stops dynamic range",
        rate: 2000,
        image: BlackMagicImg
      },
      {
        code: "A04",
        title: "Sony A7R V Mirrorless Camera",
        description: "61MP full-frame mirrorless with 8K video, advanced AI autofocus",
        rate: 1800,
        image: a7r5Img
      },
      {
        code: "A05",
        title: "Sony A7R IV Mirrorless Camera",
        description: "61MP full-frame mirrorless with 4K video, real-time eye AF",
        rate: 1500,
        image: a7r4Img
      },
      {
        code: "A06",
        title: "Canon 5D MK IV",
        description: "30.4MP full-frame DSLR with 4K video, Dual Pixel AF",
        rate: 1200,
        image: canonImg
      },
      {
        code: "A07",
        title: "GoPro Hero 10",
        description: "Compact action camera with 5.3K video, HyperSmooth stabilization",
        rate: 800,
        image: goproImg
      }
    ]
  },
  {
    category: "DRONES",
    image: "/images/categories/drones.jpg",
    items: [
      {
        code: "B01",
        title: "DJI Phantom 4 Pro",
        description: "Professional drone with 1-inch 20MP sensor, 4K/60fps video",
        rate: 3000,
        image: phantom4Img
      },
      {
        code: "B02",
        title: "DJI Mavic Air 2",
        description: "Compact drone with 48MP photos, 4K/60fps video",
        rate: 2500,
        image: mavicAirImg
      },
      {
        code: "B03",
        title: "DJI Mavic 2 Pro",
        description: "Professional drone with Hasselblad camera, 1-inch CMOS sensor",
        rate: 2800,
        image: mavic2Img
      }
    ]
  },
  {
    category: "LENSES",
    image: "/images/categories/lenses.jpg",
    items: [
      {
        code: "C01",
        title: "Sony FE 70-200mm F2.8 G-Master OSS",
        description: "Professional telephoto zoom lens with fast f/2.8 aperture",
        rate: 1500,
        image: sony70200Img
      },
      {
        code: "C02",
        title: "Sony FE 24-70mm F2.8 G-Master",
        description: "Standard zoom lens with constant f/2.8 aperture",
        rate: 1200,
        image: sony2470Img
      },
      {
        code: "C03",
        title: "Canon 70-200mm f/2.8L IS II USM",
        description: "Professional L-series telephoto zoom with image stabilization",
        rate: 1300,
        image: canon70200Img
      },
      {
        code: "C04",
        title: "Metabones Lens Mount Adapter",
        description: "Adapter for using Canon EF lenses on Sony E-mount cameras",
        rate: 500,
        image: metabonesImg
      }
    ]
  },
  {
    category: "LIGHTS",
    image: "/images/categories/lights.jpg",
    items: [
      {
        code: "D01",
        title: "Amaran 200x",
        description: "Bi-color LED light with 200W output, Bowens mount",
        rate: 1000,
        image: amaran200xImg
      },
      {
        code: "D02",
        title: "Amaran 200d",
        description: "Daylight LED light with 200W output, high CRI",
        rate: 1000,
        image: amaran200dImg
      },
      {
        code: "D03",
        title: "Amaran 300c",
        description: "RGBWW LED light with 300W output, full color spectrum",
        rate: 1500,
        image: amaran300cImg
      },
      {
        code: "D04",
        title: "Arri SkyPanel S30 RGB",
        description: "Professional RGB LED panel with high output",
        rate: 3000,
        image: arriS30rgbImg
      },
      {
        code: "D05",
        title: "Arri SkyPanel S30-RP",
        description: "Daylight LED panel with high CRI and wireless control",
        rate: 2800,
        image: arriS30rpImg
      },
      {
        code: "D06",
        title: "1.2K HMI Light",
        description: "High-power daylight-balanced HMI with flicker-free operation",
        rate: 3500,
        image: hmi1200Img
      },
      {
        code: "D07",
        title: "Godox SL-1000W LED Light",
        description: "1000W daylight LED with high CRI and Bowens mount",
        rate: 1200,
        image: godoxSl1000Img
      },
      {
        code: "D08",
        title: "Aputure 300D",
        description: "Daylight LED light with 300W output and wireless control",
        rate: 1800,
        image: aputure300dImg
      },
      {
        code: "D09",
        title: "Aputure 300X",
        description: "Daylight LED light with 300W output, improved cooling",
        rate: 1900,
        image: aputure300xImg
      },
      {
        code: "D10",
        title: "Aputure 600D",
        description: "600W daylight LED light with high output",
        rate: 2500,
        image: aputure600dImg
      },
      {
        code: "D11",
        title: "Aputure 600X",
        description: "600W daylight LED with improved cooling system",
        rate: 2600,
        image: aputure600xImg
      },
      {
        code: "D12",
        title: "Aputure 1,200D Pro",
        description: "1200W daylight LED with massive output",
        rate: 4000,
        image: aputure1200dImg
      },
      {
        code: "D13",
        title: "Neewer Softbox Lighting Kit",
        description: "Complete softbox kit with stands, bulbs, and diffusers",
        rate: 800,
        image: neewerSoftboxImg
      }
    ]
  },
  {
    category: "GRIPS",
    image: "/images/categories/grips.jpg",
    items: [
      {
        code: "E01",
        title: "DJI Ronin S3 Pro",
        description: "Professional 3-axis gimbal for cinema cameras up to 10kg",
        rate: 2000,
        image: djiRoninS3Img
      },
      {
        code: "E02",
        title: "DJI Ronin S2",
        description: "3-axis gimbal for mirrorless and small cinema cameras",
        rate: 1500,
        image: djiRoninS2Img
      },
      {
        code: "E03",
        title: "DJI Ronin S4",
        description: "Advanced 3-axis gimbal with improved payload",
        rate: 2200,
        image: djiRoninS4Img
      },
      {
        code: "E04",
        title: "Camera Dolly",
        description: "Professional camera dolly with track system",
        rate: 1800,
        image: cameraDollyImg
      },
      {
        code: "E05",
        title: "Manfrotto 504 Tripod",
        description: "Heavy-duty video tripod with fluid head",
        rate: 1200,
        image: manfrotto504Img
      },
      {
        code: "E06",
        title: "Manfrotto Monopod",
        description: "Professional monopod with fluid tilt head",
        rate: 800,
        image: manfrottoMonopodImg
      },
      {
        code: "E07",
        title: "C-stands (Set of 3)",
        description: "Professional grip stands with arms and sandbags",
        rate: 1000,
        image: cStandsImg
      },
      {
        code: "E08",
        title: "Standard Light Stands (Set of 3)",
        description: "8' light stands with carrying case",
        rate: 600,
        image: lightStandsImg
      },
      {
        code: "E09",
        title: "High Roller Stands",
        description: "Tall stands for overhead lighting setups",
        rate: 800,
        image: highRollerImg
      },
      {
        code: "E10",
        title: "Heavy Duty Stands",
        description: "Extra strong stands for heavy lighting equipment",
        rate: 900,
        image: heavyStandsImg
      }
    ]
  },
  {
    category: "AUDIO",
    image: "/images/categories/audio.jpg",
    items: [
      {
        code: "F01",
        title: "Sennheiser G4 Lavalier Mic",
        description: "Professional wireless lavalier microphone system",
        rate: 1200,
        image: sennheiserG4Img
      },
      {
        code: "F02",
        title: "Sennheiser Boom M16 Mic",
        description: "Professional shotgun microphone with boom pole",
        rate: 1000,
        image: sennheiserM16Img
      },
      {
        code: "F03",
        title: "Sound Devices MixPre Audio Recorder",
        description: "Compact professional audio recorder with high-quality preamps",
        rate: 1500,
        image: mixpreRecorderImg
      },
      {
        code: "F04",
        title: "Zoom H6 Audio Recorder",
        description: "Portable 6-track audio recorder with interchangeable capsules",
        rate: 1000,
        image: zoomH6Img
      }
    ]
  },
  {
    category: "OTHER EQUIPMENT",
    image: "/images/categories/other-equipment.jpg",
    items: [
      {
        code: "G01",
        title: "Extension Cables (Set of 3)",
        description: "Heavy-duty 50ft extension cables",
        rate: 300,
        image: extensionCablesImg
      },
      {
        code: "G02",
        title: "Roll Cables",
        description: "Professional cable management system",
        rate: 400,
        image: rollCablesImg
      },
      {
        code: "G03",
        title: "Dividers",
        description: "Set of scene dividers/flags for lighting control",
        rate: 500,
        image: dividersImg
      },
      {
        code: "G04",
        title: "Electric Generator (5KW)",
        description: "Portable silent generator for location shoots",
        rate: 2500,
        image: generatorImg
      },
      {
        code: "G05",
        title: "Memory Cards (Set of 3)",
        description: "128GB high-speed CFexpress/SD cards",
        rate: 800,
        image: memoryCardsImg
      }
    ]
  },
  {
    category: "LOGISTICS SERVICES",
    image: "/images/categories/logistics.jpg",
    items: [
      {
        code: "H01",
        title: "Equipment Delivery",
        description: "Professional delivery service for equipment to your location",
        rate: 1500,
        image: deliveryServiceImg
      },
      {
        code: "H02",
        title: "Equipment Pickup",
        description: "Convenient pickup service after your rental period",
        rate: 1500,
        image: pickupServiceImg
      }
    ]
  }
];

export { equipmentProducts };